import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.75 7.25V1H7.25V7.25H1V8.75H7.25V15H8.75V8.75H15V7.25H8.75Z", fill: "currentColor" }));
export default SvgPlus;
